<template>
  <NuxtLayout name="clean">
    <div class="branding" overflow-y-auto w-full>
      <slot />
    </div>
  </NuxtLayout>
</template>
